import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_HOMEPAGE_PETITION_MARQUEE = defineFcm('homepage_petition_marquee')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				isEnabled: { type: 'boolean' },
				petitions: {
					type: 'array',
					shape: {
						type: 'object',
						shape: {
							petitionId: { type: 'number' },
							summarizedTitle: { type: 'string' },
							// optional so entries curated before this flag existed keep normalizing
							usePetitionPhoto: { type: 'boolean', optional: true },
						},
					},
				},
			},
		}),
	)
	.withDefault({
		isEnabled: false,
		petitions: [],
	})
	.toConfig({
		owner: 'squad-narwhal',
		scope: 'corgi-middle-end',
		supportedGroups: { countries: true },
		context: 'Homepage petition marquee',
		description:
			'Curated petitions shown in the homepage marquee. The petition ID is used to grab associated data. \n The `summarizedTitle` is used as a petition title for the rendered card. `usePetitionPhoto` determines whether a user’s avatar or petition photo is used for the card.\n\nEach card shows the image, title and signature count, and renders as a victory when the petition has won and as trending otherwise. An entry whose petition cannot be shown (closed, unpublished, or with no usable image) is skipped, and the remaining petitions fill the row.',
		template: {
			isEnabled: true,
			petitions: [
				{
					petitionId: 123456,
					summarizedTitle: 'Protect the national parks',
					usePetitionPhoto: false,
				},
				{
					petitionId: 789012,
					summarizedTitle: 'Save the local library',
					usePetitionPhoto: true,
				},
			],
		},
	});
